<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form :form="form" layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="计划名称" :help="null">
              <global-select
                v-decorator="['planName', { rules: [{ required: true }] }]"
                requestApi="/scp/scpMrpPlans/planNameBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ dataType: 2, planType: 101 }"
                :allowClear="false"
                @change="changePlanName"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="计划版本" :help="null">
              <global-select
                v-decorator="['planVersion', { rules: [{ required: true }] }]"
                selectType="selectAssembleSearch"
                requestApi="/scp/scpMrpPlans/planVersionBox"
                :selectItem="{ value: 'realValue', label: 'label', thirdLabel: 'bringOutDataOne', thirdLabelText: '最新版本' }"
                :setParams="{ dataType: 2, planType: 101, planName: form.getFieldsValue().planName }"
                searchParam="planVersion"
                :allowClear="false"
                @change="changeVersion"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="组织">
              <global-select
                v-decorator="['organizationCode', { initialValue: organizationCodeOrigin }]"
                requestApi="/scp/scpMrpPlans/planOrganizationBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ dataType: 2, planName: form.getFieldsValue().planName, planVersion: form.getFieldsValue().planVersion, planType: 101 }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="计划员">
              <global-select
                v-decorator="['plannerCodeList']"
                selectType="selectMultiple"
                requestApi="/system/user/allJobCodeName"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="物料编码">
              <global-select
                v-decorator="['itemIdList']"
                selectType="selectMultipleSearch"
                :dropdown-match-select-width="false"
                requestApi="/scp/scpMrpSystemItems/planItemsBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ planName: form.getFieldsValue().planName, planVersion: form.getFieldsValue().planVersion, organizationCode: form.getFieldsValue().organizationCode || organizationCodeOrigin }"
                searchParam="label"
                sourseField="res"
                :totalNum="9999999999"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="物料类别">
              <a-tree-select
                v-decorator="['categoryIdList']"
                :dropdown-style="{
                  maxHeight: '50vh'
                }"
                :tree-data="treeData"
                :max-tag-count="1"
                :replaceFields="{children: 'child', title: 'name', key: 'segment', value: 'id' }"
                tree-checkable
                allow-clear
                tree-node-filter-prop="title"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="建议下达日期" :labelCol="{ style: { width: '90px' } }">
              <a-tooltip>
                <template slot="title">{{ $timeText(form.getFieldsValue().deliveryDate, 'YYYY-MM-DD') }}</template>
                <a-range-picker v-decorator="['deliveryDate']" valueFormat="YYYY-MM-DD" allowClear @change="handleDeliveryDateChange"/>
              </a-tooltip>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="状态">
              <global-select
                v-decorator="['status']"
                selectType="select"
                requestApi="/system/lookup/data/list"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :setParams="{ lookupType: 'SCP_MRP_RELEASE_STATUS' }"
                :allowClear="true"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="MRP版本">
              <global-select
                ref="mrpSelectRef"
                v-decorator="['mrpVersionNumber', { rules: [{ required: true }] }]"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :selectData="mrpList"
                selectType="selectFilter"
                :allowClear="false"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="onSearch" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <a-form layout="inline" :labelCol="{ style: { width: '100px' } }">
          <a-row class="align-center">
            <div class="plan-time pt5 pb5">计划运行概况</div>
            <a-col :md="7" :sm="24" class="ml20">
              <a-form-item label="主计划版本">
                <a-input v-model="planVersion" disabled />
              </a-form-item>
            </a-col>
            <a-col :md="7" :sm="24">
              <a-form-item label="数据收集时间">
                <a-input v-model="dataCollectStartDate" disabled />
              </a-form-item>
            </a-col>
            <a-col :md="7" :sm="24">
              <a-form-item label="计划运算完成时间" :labelCol="{ style: { width: '120px' } }">
                <a-input v-model="planCompletionDate" disabled />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <div class="table-page-operator-wrapper mt5 mb10">
          <a-button @click="handleExport" v-hasPermi="['scp:scpMrpReleaseDetail:purchasingPlanExport']">导出</a-button>
          <a-button :disabled="selectedRows.length === 0" :loading="fbLoading" type="primary" @click="handleFb()" v-hasPermi="['scp:scpMrpReleaseDetail:release']">发布</a-button>
          <a-button @click="handleZbfb()" v-hasPermi="['scp:scpMrpReleaseDetail:fullVersionRelease']">整版发布</a-button>
          <a-button @click="importExcelHandleOpen()" v-hasPermi="['scp:scpMrpReleaseDetail:import']">导入并发布</a-button>
        </div>
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          :selectedRows.sync="selectedRows"
          rowKey="serialNumber"
          :scroll="{ x: tableX, fixScreen: true }"
          @selectedRowChange="selectedRowChange"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.FOR_GOODS_PLAN_LIST, // 表格方案配置唯一值
              }"
        >
          <span slot="implementDateTitle">
            <i class="toRequired">*</i>要求到货日期
          </span>
          <span slot="implementQuantityTitle">
            <i class="toRequired">*</i>发布数量
          </span>
          <template v-for="item in columns" :slot="item.dataIndex" slot-scope="{ text, record }">
            <div :key="item.dataIndex">
              <span v-if="item.dataIndex === 'operation'">
                <a v-if="(!isEdit || currentId !== record.id) && record.status === 'UNRELEASE'" @click="handleEdit(record)" v-hasPermi="['scp:scpMrpReleaseDetail:edit']">编辑</a>
                <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
                <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
              </span>
              <span v-if="item.type === 'date'">
                <span v-if="!isEdit || currentId !== record.id">{{ text && $moment(text).format('YYYY-MM-DD') }}</span>
                <a-date-picker v-if="isEdit && currentId === record.id" v-model="record[item.dataIndex]" valueFormat="YYYY-MM-DD" size="small" />
              </span>
              <span v-else-if="item.type === 'inputNumber'">
                <span v-if="!isEdit || currentId !== record.id">{{ record[item.dataIndex] }}</span>
                <a-input-number v-if="isEdit && currentId === record.id" v-model="record[item.dataIndex]" :min="0" size="small" />
              </span>
              <span v-else-if="item.type === 'textarea'">
                <span v-if="!isEdit || currentId !== record.id">{{ record[item.dataIndex] }}</span>
                <a-textarea v-if="isEdit && currentId === record.id" :maxLength="50" v-model="record[item.dataIndex]" size="small" />
              </span>
              <span v-else-if="item.type === 'text'">{{ text && $moment(text).format('YYYY-MM-DD') }}</span>
              <span v-else>{{ text }}</span>
            </div>
          </template>
        </ls-api-table>
      </div>
      <!-- 上传文件 -->
      <a-modal
        :title="upload.title"
        :visible="excelVisible"
        @ok="importExcelHandleCancel"
        @cancel="importExcelHandleCancel"
      >
        <a-upload-dragger
          name="file"
          accept=".xlsx, .xls"
          :multiple="true"
          :headers="upload.headers"
          :action="`${upload.url}`"
          @change="importExcelHandleChange"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p>
          <p class="ant-upload-text">
            请将文件拖拽到此处上传
          </p>
          <p class="ant-upload-hint">
            支持单个或批量上传，也可以点击后选择文件上传
          </p>
        </a-upload-dragger>
      </a-modal>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import {
  apiScpMrpReleaseDetailList,
  apiScpMrpCategoryCodeCategoryBox,
  apiScpMrpPlansCallMaterialPlanExecutionTime,
  apiScpMrpReleaseDetailRelease,
  apiScpMrpReleaseDetailFullVersionRelease,
  apiScpMrpReleaseDetailUpdate,
  apiScpMrpVersionNumberBox
} from '@/api/scp/reserve-goods-plan/for-goods-plan'
import { generateLsTableResData } from '@/utils/util.js';
import Cookies from 'js-cookie';
import moment from 'moment'
export default {
  // eslint-disable-next-line
  name: 'For-goods-plan', // name要和rms配置菜单路由保存一致(首字母大写)
  components: {},
  data () {
    const token = (process.env.NODE_ENV === "development" || localStorage.getItem('isFromSystemLogin') === 'true') ? localStorage.getItem('token') : Cookies.get('Admin-Token')
    const Authorization = token ? 'Bearer ' + token : undefined;
    return {
      // 导入excel
      excelVisible: false,
      // 用户导入参数
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: '导入Excel',
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的用户数据
        updateSupport: 0,
        // 设置上传的请求头部
        headers: { Authorization: Authorization },
        // 上传的地址
        url: process.env.VUE_APP_API_BASE_URL + '/scp/scpMrpReleaseDetail/import'
      },
      isEdit: false,
      currentId: "",
      tableProps: {
        requestApi: generateLsTableResData(apiScpMrpReleaseDetailList, true),
        pageCurrent: true
      },
      // 查询参数
      form: this.$form.createForm(this),
      // 控制搜索展开
      advanced: true,
      // 表格数据
      tableX: 2500,
      tableList: [],
      mrpList: [], // mrp版本列表
      // 表格字段
      columns: [
        {
          title: '组织',
          dataIndex: 'organizationName',
          align: 'center',
          width: 120,
          stickyFixed: 'left'
        },
        {
          title: '主体',
          dataIndex: 'mainBody',
          align: 'center',
          width: 100,
          stickyFixed: 'left',
          ellipsis: true
        },
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          align: 'center',
          width: 120,
          stickyFixed: 'left',
          ellipsis: true
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          align: 'center'
        },
        {
          title: '规格描述',
          dataIndex: 'specification',
          align: 'center',
          ellipsis: true
        },
        {
          title: '单位',
          dataIndex: 'uom',
          align: 'center'
        },
        {
          title: '供应商',
          dataIndex: 'supplierName',
          align: 'center'
        },
        {
          title: '建议下达日期',
          dataIndex: 'suggestOrderDate',
          align: 'center',
          scopedSlots: { customRender: 'suggestOrderDate' },
          type: "text"
        },
        {
          // title: '要求到货日期',
          customTitle: '要求到货日期',
          dataIndex: 'implementDate',
          align: 'center',
          scopedSlots: { customRender: 'implementDate', title: "implementDateTitle" },
          type: "date",
          width: 170
        },
        {
          // title: '发布数量',
          customTitle: '发布数量',
          dataIndex: 'implementQuantity',
          align: 'center',
          scopedSlots: { customRender: 'implementQuantity', title: "implementQuantityTitle" },
          type: "inputNumber"
        },
        {
          title: '状态',
          dataIndex: 'statusName',
          align: 'center'
        },
        {
          title: 'MPQ',
          dataIndex: 'fixedLotMultiplier',
          align: 'center'
        },
        {
          title: '备库LT',
          dataIndex: 'safetyStockLeadTime',
          align: 'center'
        },
        {
          title: '当前DOI',
          dataIndex: 'doi',
          align: 'center'
        },
        {
          title: '原计划日期',
          dataIndex: 'scheduleDate',
          align: 'center',
          scopedSlots: { customRender: 'scheduleDate' },
          type: "text"
        },
        {
          title: '原数量',
          dataIndex: 'scheduleQuantity',
          align: 'center'
        },
        {
          title: '发布日期',
          dataIndex: 'releaseDate',
          align: 'center',
          scopedSlots: { customRender: 'releaseDate' },
          type: "text"
        },
        {
          title: '计划名称',
          dataIndex: 'planName',
          align: 'center'
        },
        {
          title: '计划版本',
          dataIndex: 'planVersion',
          align: 'center'
        },
        {
          title: 'MRP版本',
          dataIndex: 'mrpVersionNumber',
          align: 'center',
          width: 140
        },
        {
          title: '备注',
          dataIndex: 'remark',
          align: 'center',
          scopedSlots: { customRender: 'remark' },
          type: 'textarea'
        },
        { title: '一级分类', dataIndex: 'name1', align: 'center', width: 100 },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ],
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      treeData: [], // 物料类别
      planVersion: "", // 主计划版本
      dataCollectStartDate: "", // 数据收集时间
      planCompletionDate: "", // 计划运算完成时间
      fbLoading: false
    }
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  created () {
    this.getSearchAllScheme()
  },
  mounted () {
    this.setDefaultDeliveryDate()
  },
  methods: {
    // 变化计划名称
    changePlanName() {
      this.form.setFieldsValue({ mrpVersionNumber: '', planVersion: '' })
      this.mrpList = [];
    },
    // 根据计划版本查询对应的MRP版本
    changeVersion(val) {
      this.mrpList = [];
      if (!val) {
        this.form.setFieldsValue({ mrpVersionNumber: '' })
        return;
      }
      apiScpMrpVersionNumberBox({ version: val }).then(res => {
        if (res?.code === 200) {
          if (res?.data?.length > 0) {
            this.mrpList = res.data;
            if (res.data[0]?.realValue) {
              this.form.setFieldsValue({ mrpVersionNumber: res.data[0].realValue })
            }
          } else {
            this.form.setFieldsValue({ mrpVersionNumber: '' })
          }
        }
      })
    },
    setDefaultDeliveryDate () {
      const formData = this.form.getFieldsValue()
      const weekOfday = moment().format('E');
      const currentWeekMonday = moment().subtract(weekOfday - 1, 'days')
      const currentWeekSunday = moment().add(7 - weekOfday, 'days')
      formData.deliveryDate = [
        currentWeekMonday,
        currentWeekSunday
      ]
      this.form.setFieldsValue(formData)
    },
    // 编辑
    handleEdit (record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.columns = JSON.parse(JSON.stringify(this.columns))
      this.isEdit = true;
      this.currentId = record.id;
    },
    // 编辑-保存
    handleSave (record) {
      const obj = JSON.parse(JSON.stringify(record))
      obj.implementDate = obj.implementDate && `${obj.implementDate} 00:00:00`
      apiScpMrpReleaseDetailUpdate(obj).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
          this.onSearch()
          this.isEdit = false
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    // 取消
    handleCancel (record) {
     this.onSearch()
     this.isEdit = false
    },
    // 发布
    handleFb () {
      this.fbLoading = true
      apiScpMrpReleaseDetailRelease(this.selectedRows).then(response => {
        if (response.code === 200) {
          this.$message.success('发布成功!')
          this.onSearch()
        } else {
          this.$message.error(response.msg)
        }
        this.fbLoading = false
      }).catch(e => {
        this.fbLoading = false
      })
    },
    // 整版发布
    handleZbfb () {
      const self = this
      this.$confirm({
        title: '发布提醒',
        content: '整版发布将发布所有符合查询条件的要货计划，请确认是否继续执行发布。',
        okText: '继续发布',
        cancelText: '取消',
        icon: () => <a-icon type='info-circle' class="color-2ea1ff" />,
        onOk () {
          apiScpMrpReleaseDetailFullVersionRelease(self.form.getFieldsValue()).then(response => {
            if (response.code === 200) {
              self.$message.success('整版发布成功!')
              self.onSearch()
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      });
    },
    // 表单搜索
    onSearch () {
      if (!this.form.getFieldsValue().planName) {
        this.$message.warning('计划名称不能为空')
        return;
      }
      if (!this.form.getFieldsValue().planVersion) {
        this.$message.warning('计划版本不能为空')
        return;
      }
      if (!this.form.getFieldsValue().mrpVersionNumber) {
        this.$message.warning('MRP版本不能为空')
        return;
      }
      this.isEdit = false
      const params = JSON.parse(JSON.stringify(this.form.getFieldsValue()))
      const deliveryDate = params.deliveryDate
      if (deliveryDate.length === 0) {
        params.startSuggestOrderDate = ""
        params.endSuggestOrderDate = ""
      } else {
        // 建议下达日期
        params.startSuggestOrderDate = deliveryDate && moment(deliveryDate[0]).format('YYYY-MM-DD') || ""
        params.endSuggestOrderDate = deliveryDate && moment(deliveryDate[1]).format('YYYY-MM-DD') || ""
      }
      this.getTableTime()
      this.$refs.dataTable.searchParams = params;
      this.$refs.dataTable.getData();
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.form.resetFields()
      this.form.setFieldsValue({ deliveryDate: [] })
      this.tableList = []
      this.onSearch()
      // if (this.$refs?.mrpSelectRef) {
      //   this.$refs.mrpSelectRef.handleSearch("");
      // }
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 导出按钮操作 */
    handleExport () {
      const params = JSON.parse(JSON.stringify(this.form.getFieldsValue()))
      const deliveryDate = params.deliveryDate
      if (deliveryDate.length === 0) {
        params.startSuggestOrderDate = ""
        params.endSuggestOrderDate = ""
      } else {
        // 建议下达日期
        params.startSuggestOrderDate = deliveryDate && moment(deliveryDate[0]).format('YYYY-MM-DD') || ""
        params.endSuggestOrderDate = deliveryDate && moment(deliveryDate[1]).format('YYYY-MM-DD') || ""
      }
      this.download('scp/scpMrpReleaseDetail/purchasingPlanExport', {
        ...params
      }, `要货计划查询/发布_${new Date().getTime()}.xlsx`)
    },
    // 物料类别-下拉框数据
    getSearchAllScheme () {
      apiScpMrpCategoryCodeCategoryBox({ parameterCode: "SCP_ITEM_CATEGORY", parameterLevelCode: "GLOBAL" }).then(res => {
        if (res.data && res.data.length > 0) {
          this.treeData = res.data
        }
      })
    },
    getTableTime () {
      // 数据收集时间、计划运算完成时间
      apiScpMrpPlansCallMaterialPlanExecutionTime(this.form.getFieldsValue()).then(res => {
        if (res.data) {
          this.planVersion = res.data.scheduleVersion
          this.dataCollectStartDate = this.$moment(res.data.dataCollectStartDate).format('YYYY-MM-DD HH:mm:ss')
          this.planCompletionDate = this.$moment(res.data.planCompletionDate).format('YYYY-MM-DD HH:mm:ss')
        }
      })
    },
    /** 行选中 */
    selectedRowChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    /** 导入excel */
    importExcelHandleChange (info) {
      const status = info.file.status
      if (status !== 'uploading') {
      }
      if (status === 'done') {
        this.$message.success(`${info.file.name}: ${info.file.response.msg}`)
      } else if (status === 'error') {
        this.$message.error(`${info.file.name}: ${info.file.response.msg}`)
      }
    },
    /** 导入excel窗体关闭 */
    importExcelHandleCancel (e) {
      this.excelVisible = false
      // 关闭后刷新列表
      this.onSearch()
    },
    /** 导入excel窗体开启 */
    importExcelHandleOpen (e) {
      this.excelVisible = true
    },
    handleDeliveryDateChange (val, valStr) {
      if (val.length === 0) {
        this.form.setFieldsValue({ deliveryDate: [] })
      }
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-select-selection__choice{
  width: 66.47px;
}
.color-2ea1ff{
  color: #2ea1ff !important;
}
</style>
